import type { BoxProps } from '@chakra-ui/react';
import { Flex, Text } from '@chakra-ui/react';
import { ReviewStars } from '@time-line/components/common';
import { useReviewedProducts } from 'hooks/reviews/useReviewedProducts';
import { aggregateProductRatings } from 'utils/reviews/aggregateProductRatings';

import { MIN_NUM_OF_REVIEWS } from '../constants';

export interface ProductReviewsStarsProps extends BoxProps {
  productSlugs: string[];
}

export function ProductReviewsStars({
  productSlugs,
  ...props
}: ProductReviewsStarsProps) {
  const { data: reviewedProducts } = useReviewedProducts({
    slugsToFilter: productSlugs,
  });
  const { ratingAverage, ratingCount, recommendedPercentage } =
    aggregateProductRatings(reviewedProducts ?? []);

  if (!productSlugs.length || ratingCount < MIN_NUM_OF_REVIEWS) return null;

  return (
    <Flex alignItems="center" {...props}>
      <ReviewStars score={ratingAverage} />
      <Text ml="4xs" size="overline" textTransform="uppercase">
        {`${ratingAverage.toFixed(1)} (${ratingCount})`}
        {recommendedPercentage != null &&
          ` · ${Math.round(recommendedPercentage)}% recommend`}
      </Text>
    </Flex>
  );
}
